import React, {useEffect} from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import './sass/style.scss?ver=1.1'; // Import a .scss or .sass file
import 'animate.css';

import Footer from './components/Footer';
import Home from './pages/Homepage/Home';
import About from './components/About';
import Services from './pages/Services/Services';
import Contact from './pages/Contact/Contact';
import Projects from './pages/Projects/Projects';
import Skills from './pages/Skills/Skills';
import ProjectDetail from './pages/ProjectDetail/ProjectDetail';
import ServiceDetail from './pages/ServiceDetail/ServiceDetail';
import NavBar from './components/NavBar/NavBar';


function App() {
  const location = useLocation();

  
  useEffect(() => {
    // Remove all custom body classes first
    document.body.className = '';

    // Add 'home-page' class if on home route
    if (location.pathname === '/') {
      document.body.classList.add('home-page');
    }
  }, [location]);


  return (
    
    <div className="App">
      <NavBar />
      <Routes>
        <Route exact={true} path="/" element={<Home/>} />
        <Route exact={true} path="/about" element={About} />
        <Route exact={true} path="/services" element={<Services />} />
        <Route exact={true} path="/contact" element={<Contact/>} />
        <Route exact={true} path="/projects" element={<Projects/>} />
        <Route  path="/projects/:id" element={<ProjectDetail/>} />
        <Route  path="/services/:id" element={<ServiceDetail/>} />
        <Route exact={true} path="/skills" element={Skills} />

        <Route to ="/" />
      </Routes>
      <Footer />

        
        
    </div>
  );
}

export default App;
